export const DATE_COLUMN_MIN_WIDTH = 133;
